"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNestedValue = void 0;
function getNestedValue(obj, path) {
    // Convert bracket notation to dot notation, then split by dot.
    var keys = path.replace(/\[(\w+)\]/g, ".$1").split(".");
    return keys.reduce(function (acc, key) { return (acc ? acc[key] : undefined); }, obj);
}
exports.getNestedValue = getNestedValue;
